const policyTypeList = [
  "Common",
  "Security",
  "Privacy",
  "Information",
  "Other",
];

export const getAddEditPolicyJson = (data, value, t) => {
  const addPolicyForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [12, 12, 12],
        fields: [
          [
            {
              id: 1,
              label: t("Policy Title"),
              type: "text",
              name: "policyTitle",
              Placeholder: t("Enter"),
              value: data["policyTitle"],
              maxLength: 35,
              validationRules: [
                {
                  required: true,
                  message: t("policy title is required"),
                },
              ],
            },
          ],
          [
            {
              id: 2,
              label: t("Policy Effective Date"),
              type: "date",
              name: "policyEffectiveDate",
              Placeholder: t("Enter"),
              value: data["policyEffectiveDate"],
              validationRules: [
                {
                  required: true,
                  message: t("Policy effective date is required"),
                },
              ],
            },
            {
              id: 4,
              label: t("Policy Type"),
              type: "select",
              name: "policyType",
              Placeholder: t("Enter"),
              value: "",
              options: policyTypeList,
              validationRules: [
                {
                  required: true,
                  message: t("Policy type is required"),
                },
              ],
            },
          ],
          // [
          //   {
          //     id: 5,
          //     label: "Policy Details",
          //     type: "editor",
          //     name: "policyDetails",
          //     Placeholder: "details",
          //     value: data["policyDetails"],
          //   },
          // ],
          [
            {
              id: 3,
              label: t("Attach File"),
              type: "dragger",
              name: "policyDocument",
              Placeholder: t("attach file"),
              value: "",
              validationRules: [
                {
                  required: true,
                  message: t("File is required"),
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: value !== "" ? t("Update") : t("Next"),
              type: "button",
              position: "end",
              textColor: "white",
              event: "submit",
            },
          ],
        ],
      },
    ],
  };

  return {
    addPolicyForm,
  };
};
